import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { GetAllAddress } from "../../api/GetAddress";
import { ToastContainer } from "react-toastify";
import axiosInstance from "../../Axios-Config/Axios-Config";
// import { ErrorToast } from "../ToastComponent/ErrorToast";
import { SuccessToast } from "../ToastComponent/SuccessToast";
import MyAddressSkelton from "./MyAddressSkelton";
import NoAddressFound from "./NoAddressFound";
// import AddressModal from "../Checkout/AddressModal";
import { SETADDRESSDATA } from "../../redux/features/delivery";
import { setSelectedAddress } from "../../redux/features/CheckoutAddress";
import Konsole from "../../utils/konsole/Konsole";
import AddressGoogleSearch from "../Checkout/GoogleAddress/AddressGoogleSearch";

export default function MyAddressView() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [deleteLoader, setDeleteLoader] = useState(false);

  const { addressData: { address }, checkoutAddress } = useSelector((state: any) => state);

  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [deletedId, setDeletedId] = useState("");
  const [selectedAddress, setSelectedEditAddress] = useState('')
  const [openDltModal, setOpenDltModal] = useState(false);

  // @@ Define use Effect
  useEffect(() => {
    getAddress();
  }, []);

  // @@ fetch all address
  const getAddress = async () => {
    GetAllAddress(dispatch);
    setLoading(false)
  }

  const onOpenModal = () => setOpen(true);
  const onOpenDltModal = () => setOpenDltModal(true);
  const onCloseDltModal = () => {
    setOpenDltModal(false);
    setSelectedEditAddress('')
  }

  // @@ address edit btn
  const handleEdit = (item: any) => {
    setSelectedEditAddress(item)
    onOpenModal();
  };
  // @@ close address modal
  const onCloseModal = () => {
    setSelectedEditAddress('')
    setOpen(false);
  };



  // console.log('openView',open)

  // @@ delete address
  const handleDelete = async () => {
    try {
      setDeleteLoader(true);
      await axiosInstance.post("delete/user/address", { id: deletedId });
      const _filteredDeletedAddress = address?.filter((i: any) => i.id != deletedId);

      // @@ clear checkout address if address checkout selected and deleted address same
      if (checkoutAddress?.selectedAddress && deletedId == checkoutAddress?.selectedAddress?.id) {
        dispatch(setSelectedAddress(''))
      }
      setDeleteLoader(false);
      dispatch(SETADDRESSDATA(_filteredDeletedAddress));
      SuccessToast(t("MyAddress.addressDeletedSuccessfully"));
      setOpenDltModal(false);
      setDeletedId("");
    } catch (error: any) {
      // setError(error.message);
      Konsole.log('error', error)
      setOpenDltModal(false);
    }
  };


  // @@ address items map
  const returnAddressItems = (label: any, value: any) => {
    return <div className="grid grid-cols-3 mb-1">
      <p className="text-[#565656]">{label}</p>
      <p className="col-span-2 capitalize">
        {value || "N/A"}
      </p>
    </div>
  }

  console.log("addressList",address)

  return (
    <>
      <div className="p-3 md:p-0 mb-12  md:mb-0">
        <div className="md:flex justify-between items-center  mb-3 hidden">
          <h1 className="text-lg font-bold ">{t("MyAddress.myAddress")}</h1>
          <button className="md:w-40 w-full h-[2.211rem] btn-secondary  flex items-center address-btn" onClick={onOpenModal}>
            <i className="fa fa-plus plus-margin-top"></i><p className=""> {t("MyAddress.addAddress")}</p>
          </button>
        </div>
        {loading ? (
          <MyAddressSkelton />
        ) : address?.length > 0 ? (
          <>
            {address.map((item: any, i: any) => (
              <div className="border rounded-md p-3 text-[.9em] mb-2" key={i}>
                {returnAddressItems(t("MyAddress.addressType"), item?.address_type)}
                {returnAddressItems(t("MyAddress.fullAddress"), item?.full_address)}
                {returnAddressItems(t("MyAddress.houseNo"), item?.house_no)}
                {returnAddressItems(t("MyAddress.streetName"), item?.street_name)}
                {returnAddressItems(t("MyAddress.country"), item?.country)}
                {/* {returnAddressItems(t("MyAddress.city"),item?.city)} */}
                {/* {returnAddressItems(t("MyAddress.zipCode"), item?.zip_code)} */}

                <div className="grid grid-cols-3 ">
                  <p className="text-[#565656]">{t("MyAddress.actions")}</p>
                  <div className="flex gap-5 items-center">
                    <p className="text-[#34558B]  cursor-pointer font-bold flex gap-1 items-center" onClick={() => handleEdit(item)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 25 24" fill="none">
                        <path d="M18.7275 1.99988C18.4715 1.99988 18.2155 2.09785 18.0205 2.29285L16.0205 4.29285L14.6064 5.70691L3.31348 16.9999V20.9999H7.31348L22.0205 6.29285C22.4115 5.90185 22.4115 5.26878 22.0205 4.87878L19.4346 2.29285C19.2396 2.09785 18.9835 1.99988 18.7275 1.99988ZM18.7275 4.41394L19.8994 5.58582L18.6064 6.87878L17.4346 5.70691L18.7275 4.41394ZM16.0205 7.12097L17.1924 8.29285L6.48535 18.9999H5.31348V17.828L16.0205 7.12097Z" fill="#34558B" />
                      </svg>
                      <p style={{ paddingTop: ".3125rem" }}> {t("MyAddress.edit")}</p>
                    </p>
                    <p className="text-[#34558B]  cursor-pointer font-bold flex gap-1 items-center" onClick={() => { onOpenDltModal(); setDeletedId(item.id); }}>
                      {/* <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 24" fill="none">
                        <path d="M10.9619 1.99988L9.96192 2.99988H3.96191V4.99988H5.07129L6.85449 20.2557V20.2635C6.98552 21.2502 7.84224 21.9999 8.83691 21.9999H17.085C18.0796 21.9999 18.9364 21.2502 19.0674 20.2635L19.0693 20.2557L20.8525 4.99988H21.9619V2.99988H15.9619L14.9619 1.99988H10.9619ZM7.08691 4.99988H18.8369L17.085 19.9999H8.83691L7.08691 4.99988Z" fill="#34558B" />
                      </svg> */}
                      <svg width="14" height="14" viewBox="0 0 44 50" fill="currentColor"><path d="M28.9062 42.1875H30.4688C30.8594 42.1875 31.25 41.8945 31.25 41.4062V14.8438C31.25 14.4531 30.8594 14.0625 30.4688 14.0625H28.9062C28.418 14.0625 28.125 14.4531 28.125 14.8438V41.4062C28.125 41.8945 28.418 42.1875 28.9062 42.1875ZM13.2812 42.1875H14.8438C15.2344 42.1875 15.625 41.8945 15.625 41.4062V14.8438C15.625 14.4531 15.2344 14.0625 14.8438 14.0625H13.2812C12.793 14.0625 12.5 14.4531 12.5 14.8438V41.4062C12.5 41.8945 12.793 42.1875 13.2812 42.1875ZM42.9688 6.25H32.8125L29.4922 1.95312C28.7109 0.878906 27.0508 0 25.7812 0H17.9688C16.6016 0 14.9414 0.878906 14.1602 1.95312L10.9375 6.25H0.78125C0.292969 6.25 0 6.64062 0 7.03125V8.59375C0 9.08203 0.292969 9.375 0.78125 9.375H3.125V45.3125C3.125 47.9492 5.17578 50 7.8125 50H35.9375C38.4766 50 40.625 47.9492 40.625 45.3125V9.375H42.9688C43.3594 9.375 43.75 9.08203 43.75 8.59375V7.03125C43.75 6.64062 43.3594 6.25 42.9688 6.25ZM16.6992 3.80859C16.8945 3.41797 17.4805 3.22266 17.9688 3.125H25.7812C26.1719 3.22266 26.7578 3.41797 26.9531 3.80859L28.9062 6.25H14.8438L16.6992 3.80859ZM37.5 45.3125C37.5 46.1914 36.7188 46.875 35.9375 46.875H7.8125C6.93359 46.875 6.25 46.1914 6.25 45.3125V9.375H37.5V45.3125ZM21.0938 42.1875H22.6562C23.0469 42.1875 23.4375 41.8945 23.4375 41.4062V14.8438C23.4375 14.4531 23.0469 14.0625 22.6562 14.0625H21.0938C20.6055 14.0625 20.3125 14.4531 20.3125 14.8438V41.4062C20.3125 41.8945 20.6055 42.1875 21.0938 42.1875Z"></path></svg>

                      <p style={{ paddingTop: ".3125rem" }}>{t("MyAddress.delete")}</p>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <NoAddressFound content={t("MyAddress.noAddress")} />
        )}

      </div>
      <div className="md:hidden fixed bottom-0 p-2 bg-white w-full">
        <button className="md:w-auto w-full bg-[#34558B] rounded-[.313rem] text-base  text-white px-16 py-4 font-bold flex items-center justify-center gap-2" onClick={onOpenModal}>
          <i className="fa fa-plus plus-margin-top"></i><p className="">{t("MyAddress.addAddress")}</p>
        </button>
      </div>
      <ToastContainer style={{ zIndex: "99999" }} />

      {/* @@START Block of Delete modal confirmation */}
      <Modal open={openDltModal} onClose={onCloseDltModal} center showCloseIcon={false} classNames={{ modal: "rounded-md ", }}>
        <div>
          <h2 className="text-base mt-6 mb-6 font-semibold"> {t("MyAddress.areYouSureWantToDeleteThisAddress")}</h2>
          <div className="flex gap-2 justify-between">
            <button onClick={() => setOpenDltModal(false)} className="border border-[#34558B] rounded-md text-[#34558B] font-semibold w-full p-3">
              {t("MyAddress.cancel")}
            </button>
            <button disabled={deleteLoader ? true : false} onClick={() => handleDelete()} className="bg-[#34558B] rounded-md text-white font-semibold w-full p-3">
              {deleteLoader ? <> <svg
                aria-hidden="true"
                role="status"
                className="inline mr-3 w-4 h-4 text-white animate-spin"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="#E5E7EB"
                ></path>
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentColor"
                ></path>
              </svg>{"Loading..."}</> : t("MyAddress.delete")}
            </button>
          </div>
        </div>
      </Modal>
      {/* @@END Block of Delete modal confirmation */}


      {/* @@START block of add/edit address modal */}
      {/* <AddressModal
        key={`${selectedAddress}${open}`}
        refrencePage='MyAddressView'
        addressModal={open}
        actionType={selectedAddress ? 'EDIT' : 'ADD'}
        setAddressModal={onCloseModal}
        selectedAddress={selectedAddress}
      /> */}
      {/* @@END block of add/edit address modal */}

      <AddressGoogleSearch 
          key={`${selectedAddress}${open}`}
          refrencePage='MyAddressView'
          addressModal={open}
          actionType={selectedAddress ? 'EDIT' : 'ADD'}
          setAddressModal={onCloseModal}
          selectedAddress={selectedAddress}
      
      />

    </>
  );
}
